import { Card } from "../_shared";
import { stableKey } from "./format";

export default function EducationCard({ entries }) {
  return (
    <Card className="p-5 lg:col-span-1" testid="admin-assessment-education">
      <h2 className="text-sm font-medium text-slate-900 mb-3">
        Education{" "}
        <span className="text-slate-400 font-normal">({entries.length})</span>
      </h2>
      {entries.length === 0 ? (
        <p className="text-sm text-slate-500">No education captured.</p>
      ) : (
        <ul className="space-y-3">
          {entries.map((e, idx) => (
            <li key={stableKey(e, `edu-${idx}`)}>
              <div className="text-sm font-medium text-slate-900">
                {e.qualification || e.field || e.level || "—"}
              </div>
              <div className="text-xs text-slate-500">
                {e.institution || ""}
                {(e.year_completed || e.year)
                  ? ` · ${e.year_completed || e.year}`
                  : ""}
              </div>
            </li>
          ))}
        </ul>
      )}
    </Card>
  );
}
